import { H2WithInfoBlock } from './H2WithInfo/H2WithInfo';
import { List } from './List/List';
import { Carousel } from './Carousel/Carousel';
import { OrderBlock } from './OrderBlock/OrderBlock';
import { Footer } from './Footer/Footer';
import { TopHeader } from './TopHeader/TopHeader';

export { H2WithInfoBlock, List, Carousel, OrderBlock, Footer, TopHeader };
